import { DOCUMENT } from '@angular/common';
import {
	Component, EventEmitter, Output, Input, OnChanges,
	SimpleChanges, ContentChild, TemplateRef, OnInit, ChangeDetectorRef, OnDestroy, Inject
} from '@angular/core';
import { LocalStorageService } from '../../../../services';


interface IRuleDescriptor {
	ruleTitle: string;
	ruleDescription: string;
	showMore: boolean;
	isSelected: boolean;
	granType: Grant;
	noState?: boolean;
	hasMore?: boolean;
}

enum DurationType {
	Daily,
	Weekly,
	Monthly
}

enum Repetition {
	Once,
	Repetitive,
	Lifetime
}

enum Grant {
	AdStorage = 'ad_storage',
	AdUserData = 'ad_user_data',
	AdPersonalization = 'ad_personalization',
	AnalyticsStorage = 'analytics_storage'
}

class WindowExt extends Window {
	consentGrant: (name: string, state: boolean) => void;
	isConsentGranted: (name: string) => boolean;
}

@Component({
	selector: 'consent',
	templateUrl: './consent.component.html',
	styleUrls: ['./consent.component.less']
})
export class ConsentComponent {
	IsShowSettings: boolean = false;
	private static LOCAL_STRORAGE_CONSENT_KEY: string = "consentUsed";
	rules: IRuleDescriptor[] = [
		{
			ruleDescription: "Consent.YourPrivacyDesc",
			ruleTitle: "Consent.YourPrivacy",
			showMore: false,
			isSelected: false,
			granType: Grant.AdPersonalization,
			noState: true,
			hasMore: true
		},
		{
			ruleDescription: "Consent.AdPersonDesc",
			ruleTitle: "Consent.AdPerson",
			showMore: false,
			isSelected: false,
			granType: Grant.AdPersonalization,
		},
		{
			ruleDescription: "Consent.AdStorageDesc",
			ruleTitle: "Consent.AdStorage",
			showMore: false,
			isSelected: false,
			granType: Grant.AdStorage,
		},
		{
			ruleDescription: "Consent.AdUserDataDesc",
			ruleTitle: "Consent.AdUserData",
			showMore: false,
			isSelected: false,
			granType: Grant.AdUserData,
		},
		{
			ruleDescription: "Consent.AnalyticsStorageDesc",
			ruleTitle: "Consent.AnalyticsStorage",
			showMore: false,
			isSelected: true,
			granType: Grant.AnalyticsStorage,
		}
	];
	isConsestUsedBefore: boolean = false;
	private window: WindowExt;
	constructor(@Inject(DOCUMENT) private document: Document, private localStrg: LocalStorageService) {
		this.window = this.document.defaultView as Window as WindowExt;
		this.isConsestUsedBefore = true;// this.isUsedConsent();

		if (!this.isConsestUsedBefore)
			this.rules.forEach(s => {
				s.isSelected = this.window.isConsentGranted(s.granType);
			});
	}

	showSettings = () => {
		this.IsShowSettings = true;
	}

	isUsedConsent = (): boolean => this.localStrg.getObject<boolean>(ConsentComponent.LOCAL_STRORAGE_CONSENT_KEY) || false;
	setUsedConsent = (): void => {
		this.localStrg.saveObject(ConsentComponent.LOCAL_STRORAGE_CONSENT_KEY, true);
		this.isConsestUsedBefore = true;
	}

	setState = (rule: IRuleDescriptor) => {
		this.window.consentGrant(rule.granType, rule.isSelected);
	}

	saveAll = () => {
		this.rules.forEach(s => {
			s.isSelected = true;
			this.window.consentGrant(s.granType, s.isSelected);
		});
		this.setUsedConsent();
	}

	saveDefault = () => {
		this.setUsedConsent();
	}

	rejectSettings = () => this.IsShowSettings = false;
}
